import axios from "axios";

import { functionBaseUrl } from "../auth/firebase";

/**
 * Ask the backend to post a "new sign language upload" message to Slack.
 *
 * This used to POST straight to hooks.slack.com from the browser, which meant
 * the webhook URL shipped in the public bundle and, because that call is a CORS
 * simple request, the response could never be read — delivery was unverifiable
 * and failures were invisible. An upload could complete with nobody notified.
 *
 * The message is now built and sent by the `notifySignLanguageUpload` function,
 * so the URL stays server-side and Slack's answer comes back to us. Rejections
 * surface as a thrown error rather than vanishing.
 *
 * @param {object} user - Redux user; needs first/last name, email, selectedAccount.
 * @param {string} videoId - Parent BC video id.
 * @param {string} uploadedUrl - Signed download URL (expires 7 days after upload).
 * @param {string} uploadId - `uploads` doc id.
 * @param {string} videoName - Parent video name, for the message body.
 */
const newSignLanguageHook = async (
  user,
  videoId,
  uploadedUrl,
  uploadId,
  videoName
) => {
  const { first_name, last_name, email } = user || {};
  const { account_id, name: account_name } = (user && user.selectedAccount) || {};

  try {
    const res = await axios({
      method: "post",
      url: `${functionBaseUrl}notifySignLanguageUpload`,
      headers: { "Content-Type": "application/json" },
      data: {
        firstName: first_name,
        lastName: last_name,
        email,
        accountName: account_name,
        accountId: account_id,
        videoId,
        videoName,
        uploadId,
        uploadedUrl,
      },
    });
    return res.data;
  } catch (err) {
    // The function returns Slack's own rejection text as the body; axios hides
    // it behind "Request failed with status code 502".
    const detail = err?.response?.data;
    if (typeof detail === "string" && detail.length > 0) {
      throw new Error(detail);
    }
    throw err;
  }
};

export { newSignLanguageHook };
